// src/pages/Home.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/ui/Button';
import Card from '../components/ui/Card';

const services = [
  {
    title: 'Custom Web Development',
    description: 'Tailor-made websites with responsive design and modern technologies.',
    icon: '💻'
  },
  {
    title: 'Billing Software',
    description: 'Streamline your invoicing process with our efficient billing software.',
    icon: '📊'
  },
  {
    title: 'Hospital Management',
    description: 'Comprehensive solutions for healthcare facilities to manage patients, staff, and resources.',
    icon: '🏥'
  },
  {
    title: 'Hotel Management',
    description: 'All-in-one system to manage bookings, guests, staff, and inventory.',
    icon: '🏨'
  },
  {
    title: 'Portfolio Websites',
    description: 'Showcase your work with elegant and professional portfolio websites.',
    icon: '🎨'
  },
  {
    title: 'Custom Software Solutions',
    description: 'Bespoke software applications tailored to your specific business needs.',
    icon: '⚙️'
  },
  {
    title: 'Support',
    description: 'We provide support on all the technologies developed by us and also support and bug fixes to the already built softwares.',
    icon: '⚙️'
  }
];

// const testimonials = [
//   {
//     name: 'Rahul Sharma',
//     company: 'City Healthcare',
//     quote: 'Tantravani completely transformed our hospital management process. Our staff is now more efficient and our patients are happier.',
//     position: 'Chief Medical Officer'
//   },
//   {
//     name: 'Priya Verma',
//     company: 'Grand Resort Hotels',
//     quote: 'The hotel management system developed by Tantravani has streamlined our operations and improved guest satisfaction.',
//     position: 'Operations Director'
//   },
//   {
//     name: 'Vikram Singh',
//     company: 'Innovative Designs',
//     quote: 'My portfolio website looks incredible! The team at Tantravani was professional, creative, and delivered exactly what I needed.',
//     position: 'Lead Designer'
//   }
// ];

const Home = () => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-indigo-800 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="md:w-1/2 mb-10 md:mb-0">
              <h1 className="text-4xl md:text-5xl font-bold mb-4">
                Custom Software Solutions for Your Business with GenAI
              </h1>
              <p className="text-xl mb-8">
                We build tailored software solutions that help businesses grow, optimize operations, and achieve digital excellence with GenAI.
              </p>
              <div className="flex flex-wrap gap-4">
                <Link to="/contact">
                  <Button>Get In Touch</Button>
                </Link>
                <Link to="/portfolio">
                  <Button variant="outline">View Our Work</Button>
                </Link>
              </div>
            </div>
            <div className="md:w-1/2">
              <div className="bg-white rounded-lg shadow-xl p-6 transform rotate-2">
                <div className="bg-gray-100 p-6 rounded-md transform -rotate-2">
                  <div className="bg-gradient-to-br from-blue-100 to-indigo-100 p-8 rounded-md shadow-inner">
                    <div className="flex items-center justify-center">
                      <img 
                        src="./poster.png" 
                        alt="Software Development" 
                        className="rounded-md shadow-lg"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">Our Services</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              We provide end-to-end software solutions tailored to your specific business requirements.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <Card key={index} className="hover:shadow-lg transition-shadow">
                <div className="text-4xl mb-4">{service.icon}</div>
                <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-10 md:mb-0">
              <img 
                src="./cross-team-collaboration.png" 
                alt="Team Collaboration" 
                className="rounded-lg shadow-lg"
              />
            </div>
            <div className="md:w-1/2 md:pl-10">
              <h2 className="text-3xl font-bold mb-6">Why Choose Tantravani?</h2>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0 bg-blue-500 rounded-full p-2 mr-4">
                    <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold">Expertise & Experience</h3>
                    <p className="text-gray-600">Our team consists of seasoned professionals with expertise in diverse technologies.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 bg-blue-500 rounded-full p-2 mr-4">
                    <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold">Customized Solutions</h3>
                    <p className="text-gray-600">We create solutions tailored specifically to your business needs, not one-size-fits-all.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 bg-blue-500 rounded-full p-2 mr-4">
                    <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold">Ongoing Support</h3>
                    <p className="text-gray-600">We don't just build and leave. We provide continuous support and maintenance.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 bg-blue-500 rounded-full p-2 mr-4">
                    <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold">Client Satisfaction</h3>
                    <p className="text-gray-600">Our primary goal is your satisfaction. We work closely with you throughout the process.</p>
                  </div>
                </div>
              </div>
              <div className="mt-8">
                <Link to="/about">
                  <Button>Learn More About Us</Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      {/* <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-12 text-center">What Our Clients Say</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-md">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                    <span className="text-blue-600 font-bold">{testimonial.name.charAt(0)}</span>
                  </div>
                  <div>
                    <h4 className="font-semibold">{testimonial.name}</h4>
                    <p className="text-sm text-gray-600">{testimonial.position}, {testimonial.company}</p>
                  </div>
                </div>
                <p className="text-gray-600 italic">"{testimonial.quote}"</p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-indigo-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Transform Your Business?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Let's discuss how our custom software solutions can help your business grow and succeed.
          </p>
          <Link to="/contact">
            <Button size="lg">Contact Us Today</Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;